export const sequences2028 = [
  ['are', 'read', 'trade', 'dreamt'],
  ['ear', 'hear', 'harem', 'hammer'],
  ['ate', 'late', 'delta', 'detail'],
  ['tea', 'beat', 'beast', 'stable'],
  ['eat', 'late', 'slate', 'stable'],
  ['are', 'year', 'relay', 'nearly'],
  ['ear', 'gear', 'argue', 'argued'],
  ['ate', 'late', 'later', 'travel'],
  ['tea', 'late', 'fetal', 'falter'],
  ['eat', 'east', 'sweat', 'wasted'],
  ['are', 'tear', 'treat', 'target'],
  ['ear', 'bear', 'break', 'banker'],
  ['ate', 'seat', 'paste', 'aspect'],
  ['tea', 'tear', 'alert', 'travel'],
  ['eat', 'late', 'alter', 'learnt'],
  ['are', 'dear', 'cared', 'scared'],
  ['ear', 'dear', 'grade', 'danger'],
  ['ate', 'tale', 'alter', 'travel'],
  ['tea', 'seat', 'steam', 'stream'],
  ['eat', 'take', 'taken', 'tanker'],
  ['are', 'care', 'reach', 'search'],
  ['ear', 'dear', 'ready', 'dearly'],
  ['ate', 'late', 'slate', 'stable'],
  ['tea', 'east', 'steal', 'stella'],
  ['eat', 'rate', 'grate', 'target'],
  ['are', 'bear', 'bread', 'barged'],
  ['ear', 'dear', 'drake', 'parked'],
  ['ate', 'tale', 'stale', 'salute'],
  ['tea', 'rate', 'water', 'waiter'],
  ['eat', 'beat', 'beast', 'stable'],
  ['are', 'read', 'raced', 'sacred'],
  ['ear', 'bear', 'brake', 'barker'],
  ['ate', 'team', 'steam', 'master'],
  ['tea', 'team', 'tamed', 'dreamt'],
  ['eat', 'tale', 'least', 'castle'],
  ['are', 'rate', 'great', 'target'],
  ['ear', 'dear', 'padre', 'spread'],
  ['ate', 'rate', 'alter', 'learnt'],
  ['tea', 'neat', 'taken', 'tanker'],
  ['eat', 'late', 'metal', 'mental'],
  ['are', 'care', 'crave', 'carver'],
  ['ear', 'dear', 'dared', 'ladder'],
  ['ate', 'seat', 'sweat', 'sweaty'],
  ['tea', 'rate', 'earth', 'father'],
  ['eat', 'team', 'matey', 'steamy'],
  ['are', 'near', 'raven', 'tavern'],
  ['ear', 'bare', 'saber', 'breast'],
  ['ate', 'date', 'dated', 'traded'],
  ['tea', 'date', 'tread', 'dreamt'],
  ['eat', 'rate', 'great', 'gather'],
  ['are', 'dare', 'drake', 'marked'],
  ['ear', 'race', 'scare', 'scared'],
  ['ate', 'seat', 'steam', 'stream'],
  ['tea', 'tear', 'terra', 'rather'],
  ['eat', 'rate', 'alert', 'albert'],
  ['are', 'earl', 'alert', 'taller'],
  ['ear', 'bare', 'brake', 'barker'],
  ['ate', 'meat', 'meant', 'inmate'],
  ['tea', 'tear', 'crate', 'racket'],
  ['eat', 'seat', 'stage', 'staged'],
  ['are', 'rate', 'treat', 'matter'],
  ['ear', 'gear', 'barge', 'badger'],
  ['ate', 'beat', 'bathe', 'breath'],
  ['tea', 'east', 'skate', 'streak'],
  ['eat', 'east', 'skate', 'streak'],
  ['are', 'read', 'drake', 'darker'],
  ['ear', 'year', 'early', 'lawyer'],
  ['ate', 'tale', 'delta', 'detail'],
  ['tea', 'seat', 'sweat', 'sweaty'],
  ['eat', 'rate', 'after', 'faster'],
  ['are', 'dare', 'heard', 'thread'],
  ['ear', 'gear', 'grace', 'charge'],
  ['ate', 'gate', 'grate', 'gather'],
  ['tea', 'seat', 'steak', 'casket'],
  ['eat', 'late', 'dealt', 'talked'],
  ['per', 'prey', 'reply', 'player'],
  ['boo', 'boot', 'robot', 'reboot'],
  ['gas', 'sang', 'slang', 'signal'],
  ['car', 'care', 'racer', 'career'],
  ['ace', 'race', 'clear', 'cellar'],
  ['lad', 'land', 'laden', 'landed'],
  ['end', 'done', 'noted', 'donate'],
  ['our', 'pour', 'proud', 'poured'],
  ['yep', 'type', 'typed', 'deputy'],
  ['nap', 'plan', 'panel', 'alpine'],
  ['bat', 'bath', 'bathe', 'bertha'],
  ['net', 'tend', 'noted', 'stoned'],
  ['per', 'rope', 'pedro', 'period'],
  ['sea', 'safe', 'safer', 'faster'],
  ['won', 'down', 'drown', 'onward'],
  ['ace', 'care', 'creak', 'racket'],
  ['tea', 'date', 'dealt', 'talked'],
  ['old', 'sold', 'solid', 'soiled'],
  ['ask', 'sake', 'asked', 'soaked'],
  ['won', 'worn', 'rowan', 'narrow'],
  ['lie', 'lied', 'filed', 'filmed'],
  ['sit', 'spit', 'spite', 'septic'],
  ['set', 'seat', 'haste', 'chaste'],
  ['sin', 'sing', 'suing', 'genius'],
  ['rat', 'rate', 'alter', 'learnt'],
  ['lad', 'lead', 'ideal', 'detail'],
  ['lie', 'live', 'alive', 'viable'],
  ['set', 'rest', 'steer', 'street'],
  ['log', 'long', 'along', 'slogan'],
  ['net', 'kent', 'taken', 'tanker'],
  ['art', 'part', 'tramp', 'armpit'],
  ['lie', 'file', 'rifle', 'filter'],
  ['sea', 'seat', 'stale', 'lasted'],
  ['win', 'wine', 'swine', 'sewing'],
  ['act', 'cart', 'trace', 'create'],
  ['map', 'palm', 'maple', 'sample'],
  ['rat', 'rate', 'grate', 'gather'],
  ['say', 'stay', 'salty', 'lastly'],
  ['pin', 'pain', 'plain', 'spinal'],
  ['lie', 'file', 'filed', 'failed'],
  ['tie', 'tire', 'timer', 'hermit'],
  ['met', 'meat', 'mater', 'market'],
  ['her', 'hear', 'earth', 'rather'],
  ['nut', 'unit', 'until', 'insult'],
  ['web', 'blew', 'bowel', 'wobble'],
  ['art', 'tear', 'trade', 'dreamt'],
  ['ran', 'darn', 'randy', 'brandy'],
  ['rat', 'rate', 'eater', 'repeat'],
  ['led', 'lead', 'pedal', 'placed'],
  ['let', 'tale', 'metal', 'hamlet'],
  ['pan', 'plan', 'panel', 'alpine'],
  ['mad', 'made', 'media', 'maiden'],
  ['red', 'dear', 'bread', 'badger'],
  ['art', 'tear', 'tread', 'hatred'],
  ['led', 'lied', 'wield', 'wilder'],
  ['low', 'blow', 'below', 'bowler'],
  ['lab', 'ball', 'label', 'liable'],
  ['his', 'this', 'shirt', 'thirst'],
  ['age', 'rage', 'sarge', 'greasy'],
  ['rub', 'burn', 'urban', 'turban'],
  ['ray', 'year', 'early', 'really'],
  ['rid', 'dirt', 'drift', 'adrift'],
  ['ask', 'task', 'steak', 'basket'],
  ['sir', 'sire', 'siren', 'singer'],
  ['see', 'seen', 'sense', 'sensed'],
  ['ace', 'race', 'creak', 'hacker'],
  ['sea', 'sale', 'lease', 'please'],
  ['ain', 'gain', 'giant', 'taking'],
  ['tie', 'tire', 'tired', 'divert'],
  ['hot', 'shot', 'those', 'honest'],
  ['pen', 'nope', 'phone', 'phoney'],
  ['let', 'late', 'least', 'castle'],
  ['see', 'ease', 'cease', 'escape'],
  ['net', 'note', 'noted', 'donate'],
  ['rat', 'tear', 'treat', 'target'],
  ['sea', 'case', 'sauce', 'accuse'],
  ['lap', 'pale', 'apple', 'appeal'],
  ['ain', 'gain', 'align', 'laying'],
  ['and', 'dean', 'laden', 'landed'],
  ['let', 'tale', 'alter', 'taller'],
  ['cap', 'pace', 'cheap', 'preach'],
  ['lap', 'plan', 'panel', 'alpine'],
  ['lit', 'list', 'spilt', 'spoilt'],
  ['set', 'seat', 'stage', 'staged'],
  ['run', 'turn', 'burnt', 'burton'],
  ['ten', 'tone', 'atone', 'donate'],
  ['ole', 'love', 'glove', 'glover'],
  ['the', 'heat', 'wheat', 'wealth'],
  ['let', 'tale', 'delta', 'talked'],
  ['pot', 'poet', 'depot', 'posted'],
  ['red', 'dear', 'aired', 'raised'],
  ['led', 'lead', 'delay', 'dearly'],
  ['lop', 'pole', 'elope', 'people'],
  ['sea', 'case', 'caste', 'aspect'],
  ['cat', 'cart', 'react', 'cartel'],
  ['run', 'turn', 'grunt', 'urgent'],
  ['ale', 'male', 'email', 'amelia'],
  ['boo', 'book', 'brook', 'brooke'],
  ['led', 'deal', 'delay', 'played'],
  ['art', 'tear', 'water', 'wreath'],
  ['nor', 'torn', 'thorn', 'thrown'],
  ['ran', 'barn', 'urban', 'turban'],
  ['sea', 'sale', 'laser', 'serial'],
  ['cat', 'fact', 'craft', 'factor'],
  ['ram', 'harm', 'harem', 'hammer'],
  ['doc', 'code', 'decor', 'record'],
  ['red', 'dear', 'cared', 'scared'],
  ['sit', 'list', 'spilt', 'spoilt'],
  ['ace', 'cave', 'crave', 'craven'],
  ['end', 'dean', 'sedan', 'sundae'],
  ['pie', 'pile', 'peril', 'triple'],
  ['red', 'rude', 'under', 'turned'],
  ['lie', 'life', 'filed', 'filled'],
  ['her', 'here', 'three', 'heater'],
  ['rip', 'pair', 'paris', 'praise'],
  ['age', 'game', 'marge', 'german'],
  ['lot', 'plot', 'pilot', 'polite'],
  ['for', 'fort', 'croft', 'factor'],
  ['she', 'shoe', 'shone', 'chosen'],
  ['bet', 'tube', 'debut', 'budget'],
  ['sin', 'sing', 'sting', 'stingy'],
  ['ray', 'yard', 'hardy', 'hardly'],
  ['pet', 'tape', 'plate', 'planet'],
  ['led', 'lied', 'yield', 'widely'],
  ['fat', 'fate', 'fetal', 'falter'],
  ['act', 'cart', 'cater', 'traced'],
  ['ray', 'army', 'marry', 'martyr'],
  ['but', 'bout', 'turbo', 'burton'],
  ['sir', 'sire', 'arise', 'easier'],
  ['bar', 'bare', 'brave', 'verbal'],
  ['tip', 'spit', 'split', 'pistol'],
  ['pie', 'pipe', 'piper', 'ripped'],
  ['sat', 'east', 'sweat', 'wasted'],
  ['too', 'root', 'troop', 'pronto'],
  ['rat', 'rate', 'alert', 'albert'],
  ['sea', 'east', 'stale', 'salute'],
  ['rob', 'born', 'borne', 'bronze'],
  ['net', 'sent', 'stein', 'listen'],
  ['end', 'done', 'devon', 'vendor'],
  ['now', 'down', 'owned', 'wonder'],
  ['pal', 'pale', 'plead', 'played'],
  ['sea', 'sake', 'snake', 'sneaky'],
  ['rid', 'ride', 'weird', 'weirdo'],
  ['ain', 'nail', 'liang', 'laying'],
  ['pay', 'pray', 'spray', 'pastry'],
  ['gay', 'gray', 'gravy', 'garvey'],
  ['top', 'poet', 'depot', 'posted'],
  ['art', 'rate', 'tread', 'dreamt'],
  ['cap', 'chap', 'cheap', 'chapel'],
  ['sea', 'seat', 'tesla', 'salute'],
  ['own', 'worn', 'owner', 'wonder'],
  ['gay', 'yang', 'angry', 'gnarly'],
  ['end', 'send', 'dense', 'tensed'],
  ['for', 'fort', 'forth', 'fourth'],
  ['age', 'rage', 'grate', 'garnet'],
  ['sat', 'east', 'stare', 'master'],
  ['eat', 'date', 'delta', 'detail'],
  ['ace', 'care', 'cared', 'sacred'],
  ['eve', 'ever', 'serve', 'served'],
  ['all', 'tall', 'stall', 'stella'],
  ['lad', 'lead', 'medal', 'blamed'],
  ['now', 'worn', 'drown', 'downer'],
  ['act', 'cast', 'stack', 'casket'],
  ['car', 'race', 'cared', 'dancer'],
  ['set', 'east', 'steal', 'castle'],
  ['rob', 'bore', 'sober', 'somber'],
  ['air', 'rain', 'grain', 'racing'],
  ['sat', 'east', 'slate', 'castle'],
  ['old', 'cold', 'scold', 'closed'],
  ['red', 'dare', 'tread', 'traced'],
  ['net', 'nest', 'stein', 'silent'],
  ['say', 'stay', 'yeast', 'stayed'],
  ['lie', 'lied', 'yield', 'widely'],
  ['let', 'left', 'filet', 'itself'],
  ['one', 'nose', 'noose', 'sooner'],
  ['red', 'ride', 'riled', 'ridley'],
  ['aid', 'idea', 'abide', 'bailed'],
  ['his', 'this', 'shift', 'fetish'],
  ['let', 'late', 'table', 'battle'],
  ['lip', 'slip', 'spilt', 'spoilt'],
  ['one', 'nope', 'phone', 'phoney'],
  ['net', 'tone', 'monte', 'mentor'],
  ['rat', 'tear', 'tread', 'hatred'],
  ['ace', 'each', 'chase', 'cashed'],
  ['ole', 'love', 'loved', 'solved'],
  ['sec', 'case', 'space', 'escape'],
  ['ran', 'near', 'crane', 'cancer'],
  ['van', 'vain', 'naive', 'native'],
  ['has', 'cash', 'crash', 'search'],
  ['ole', 'cole', 'clone', 'cloned'],
  ['per', 'pure', 'purge', 'purged'],
  ['pie', 'pile', 'piled', 'dimple'],
  ['red', 'read', 'ready', 'dearly'],
  ['sin', 'skin', 'stink', 'stinky'],
  ['one', 'bone', 'noble', 'belong'],
  ['die', 'tide', 'tired', 'divert'],
  ['not', 'torn', 'north', 'thrown'],
  ['car', 'cart', 'trace', 'carpet'],
  ['lad', 'dale', 'pedal', 'played'],
  ['ace', 'case', 'chase', 'chased'],
  ['one', 'note', 'stone', 'stolen'],
  ['red', 'deer', 'greed', 'agreed'],
  ['ain', 'nail', 'final', 'finale'],
  ['rat', 'cart', 'cater', 'cartel'],
  ['ray', 'year', 'repay', 'player'],
  ['set', 'test', 'taste', 'latest'],
  ['red', 'reed', 'freed', 'fender'],
  ['led', 'deal', 'blade', 'blamed'],
  ['mac', 'came', 'cream', 'camera'],
  ['sea', 'base', 'based', 'abused'],
  ['tip', 'trip', 'strip', 'spirit'],
  ['hot', 'thou', 'touch', 'touchy'],
  ['sat', 'seat', 'state', 'estate'],
  ['ten', 'sent', 'tense', 'senate'],
  ['her', 'hear', 'reach', 'charge'],
  ['lap', 'palm', 'maple', 'sample'],
  ['car', 'scar', 'cards', 'scared'],
  ['sea', 'seal', 'tesla', 'castle'],
  ['ten', 'rent', 'entry', 'trendy'],
  ['ham', 'ahem', 'shame', 'mashed'],
  ['ran', 'rang', 'angry', 'granny'],
  ['ole', 'lose', 'stole', 'stolen'],
  ['far', 'fear', 'after', 'father'],
  ['ace', 'race', 'carve', 'carver'],
  ['cat', 'chat', 'teach', 'chaste'],
  ['map', 'palm', 'ample', 'palmer'],
  ['row', 'wore', 'lower', 'flower'],
  ['now', 'down', 'drown', 'onward'],
  ['rid', 'ride', 'rider', 'raider'],
  ['ale', 'male', 'blame', 'gamble'],
  ['car', 'cart', 'track', 'racket'],
  ['lad', 'lady', 'delay', 'dearly'],
  ['rat', 'trap', 'tramp', 'tamper'],
  ['pat', 'part', 'party', 'partly'],
  ['ale', 'male', 'camel', 'marcel'],
  ['aim', 'mail', 'claim', 'climax'],
  ['sat', 'past', 'patsy', 'pastry'],
  ['rat', 'cart', 'trace', 'carpet'],
  ['can', 'clan', 'clean', 'cancel'],
  ['met', 'item', 'timer', 'timber'],
  ['web', 'blew', 'below', 'bowler'],
  ['red', 'ride', 'fried', 'fridge'],
  ['hip', 'chip', 'chirp', 'cipher'],
  ['see', 'seen', 'dense', 'tensed'],
  ['age', 'gear', 'great', 'gather'],
  ['lie', 'life', 'field', 'failed'],
  ['red', 'ride', 'hired', 'hinder'],
  ['low', 'blow', 'elbow', 'blower'],
  ['her', 'heir', 'their', 'thrive'],
  ['bar', 'brad', 'bread', 'barbed'],
  ['pal', 'pale', 'pedal', 'placed'],
  ['cat', 'cart', 'cater', 'traced'],
  ['ran', 'rang', 'anger', 'ranger'],
  ['car', 'card', 'cedar', 'sacred'],
  ['pin', 'pain', 'paint', 'taping'],
  ['now', 'worn', 'rowan', 'narrow'],
  ['fee', 'feed', 'freed', 'fender'],
  ['fit', 'gift', 'fight', 'flight'],
  ['sea', 'east', 'beast', 'basket'],
  ['car', 'race', 'recap', 'parcel'],
  ['end', 'dean', 'named', 'demand'],
  ['bid', 'bird', 'rabid', 'bridal'],
  ['man', 'main', 'mania', 'animal'],
  ['did', 'died', 'dried', 'riddle'],
  ['red', 'rude', 'crude', 'reduce'],
  ['rat', 'tear', 'trade', 'dreamt'],
  ['ace', 'pace', 'place', 'palace'],
  ['set', 'seat', 'caste', 'aspect'],
  ['art', 'cart', 'chart', 'starch'],
  ['red', 'dare', 'armed', 'framed'],
  ['act', 'cart', 'react', 'cartel'],
  ['her', 'hero', 'homer', 'hombre'],
  ['ice', 'rice', 'cried', 'direct'],
  ['get', 'gate', 'stage', 'staged'],
  ['sat', 'east', 'beast', 'basket'],
  ['ran', 'near', 'yearn', 'nearby'],
  ['men', 'name', 'named', 'maiden'],
  ['bro', 'bore', 'bored', 'border'],
  ['lie', 'pile', 'peril', 'triple'],
  ['sat', 'seat', 'stare', 'faster'],
  ['red', 'dare', 'rated', 'traded'],
  ['sea', 'seal', 'scale', 'solace'],
  ['air', 'raid', 'triad', 'adrift'],
  ['hat', 'chat', 'chart', 'starch'],
  ['sat', 'seat', 'taste', 'statue'],
  ['ace', 'race', 'trace', 'cartel'],
  ['sea', 'seat', 'state', 'estate'],
  ['own', 'worn', 'rowan', 'narrow'],
  ['inn', 'nine', 'inner', 'dinner'],
  ['act', 'chat', 'yacht', 'chatty'],
  ['bar', 'bear', 'amber', 'marble'],
];